import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faTrash,
  faBong,
  faFileAlt,
  faCircleNotch,
  faCheck,
  faPlus,
  faTimes,
  faMinus,
  faSave,
  faFolder,
  faAdjust,
  faSignature,
  faSortNumericUpAlt,
  faFile,
  faCalendarDay,
  faFont,
  faQuoteLeft,
  faCheckSquare,
  faCaretDown,
  faCaretUp,
  faStickyNote,
  faWindowMaximize,
  faMicrophone,
  faCircle,
  faPlay,
  faPause,
  faStop,
  faTerminal,
  faClone,
  faEllipsisV,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons'

library.add(faTrash)
library.add(faBong)
library.add(faFileAlt)
library.add(faCircleNotch)
library.add(faCheck)
library.add(faPlus)
library.add(faTimes)
library.add(faMinus)
library.add(faSave)
library.add(faFolder)
library.add(faAdjust)
library.add(faSignature)
library.add(faSortNumericUpAlt)
library.add(faFile)
library.add(faCalendarDay)
library.add(faFont)
library.add(faQuoteLeft)
library.add(faCheckSquare)
library.add(faCaretDown)
library.add(faCaretUp)
library.add(faStickyNote)
library.add(faWindowMaximize)
library.add(faMicrophone)
library.add(faCircle)
library.add(faPlay)
library.add(faPause)
library.add(faStop)
library.add(faTerminal)
library.add(faClone)
library.add(faEllipsisV)
library.add(faChevronDown)

Vue.component('icon', FontAwesomeIcon)
